module.exports = __webpack_public_path__ + "img/notice.7698fc7b.png";